module.exports = __webpack_public_path__ + "media/images/pic/teachers/krzysztof-walaszek-85187670f45ae94f516e1670b18a6f93.webp";